import React from "react";
import { motion } from "framer-motion";

export default function SectionHeading({ overline, title, description, align = "left" }) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}
      className={`flex flex-col ${alignCls} mb-12 md:mb-16`}
    >
      {overline && (
        <div className="flex items-center gap-3 mb-4">
          <span className="h-px w-8 bg-[color:var(--accent)]" />
          <span className="label-mono text-[color:var(--accent)]">{overline}</span>
        </div>
      )}
      <h2 className="font-display text-4xl md:text-6xl text-[color:var(--text)]">{title}</h2>
      {description && (
        <p className="mt-5 max-w-2xl text-base md:text-lg text-[color:var(--text-muted)] font-body">
          {description}
        </p>
      )}
    </motion.div>
  );
}
